import React from 'react';

export type Currency = 'USD' | 'INR';

interface CurrencySelectorProps {
  selectedCurrency: Currency;
  onCurrencyChange: (currency: Currency) => void;
  className?: string;
}

const currencies = [
  {
    code: 'USD' as Currency,
    name: 'USD',
    symbol: '$',
    provider: 'Stripe',
  },
  {
    code: 'INR' as Currency,
    name: 'INR',
    symbol: '₹',
    provider: 'Razorpay',
  },
];

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  selectedCurrency,
  onCurrencyChange,
  className = '',
}) => {
  return (
    <div className={`d-flex align-items-center gap-2 ${className}`}>
      <span className="text-muted small me-1">Currency:</span>
      {currencies.map((currency) => (
        <button
          key={currency.code}
          type="button"
          className={`currency-btn ${selectedCurrency === currency.code ? 'active' : ''}`}
          onClick={() => onCurrencyChange(currency.code)}
        >
          <span className="currency-symbol">{currency.symbol}</span>
          <span>{currency.name}</span>
        </button>
      ))}
    </div>
  );
};

export default CurrencySelector;
